import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { CEILING_FITTING_MAX_HEIGHT_MM } from '../../Constants';

/**
 * 建具詳細設定
 * 高さ、取付高さの設定を行うことができる。（手動・自動選択もある）
 */
class FittingSetting extends Dialog {
    targetFitting: marietta.webcad.item.Fitting;

    initDone: boolean = false; // 初期化完了

  // 建具の上限下限(mm)
  private readonly FITTING_MAX_HEIGHT: number = CEILING_FITTING_MAX_HEIGHT_MM;
  private readonly FITTING_MIN_HEIGHT: number = 100;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);
      // ターゲットのお部屋
      this.targetFitting = marietta.webcad.WebCADGlobal.itemManager.currentItem as marietta.webcad.item.Fitting;
      this.initDone = false;

      // 選択肢リストの作成
      let mySetting;
      for (let i: number = 0; i < marietta.webcad.WebCADGlobal.FITTING_CONFIG_ITEMS.length; i += 1) {
        if (marietta.webcad.WebCADGlobal.FITTING_CONFIG_ITEMS[i].id === this.targetFitting.itemInfo.id) {
          mySetting = marietta.webcad.WebCADGlobal.FITTING_CONFIG_ITEMS[i];
          break;
        }
      }
      if (mySetting === null || mySetting === undefined) {
        for (let i = 0; i < marietta.webcad.WebCADGlobal.FITTING_CONFIG_ITEMS.length; i += 1) {
          if (marietta.webcad.WebCADGlobal.FITTING_CONFIG_ITEMS[i].id === 'fit00_00') {
            mySetting = marietta.webcad.WebCADGlobal.FITTING_CONFIG_ITEMS[i];
            break;
          }
        }
      }

      // 高さリストの設定
      const heightList = <HTMLSelectElement>mySetting.heightList;
      heightList.setAttribute('name', 'fittingHeight');
      heightList.setAttribute('id', 'fittingHeight');

      // ダイアログのコンテンツ生成
      const id = 'fittingSettingDialog';
      let title = '建具詳細設定';

      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = 'Fitting Setting'; break;
        default: title = '建具詳細設定'; break;
      }

      // シェアモードでは閲覧のみとするため、自動・手動の切り替えとOK・キャンセルを生成しない
      const isShareMode: boolean = marietta.webcad.WebCADGlobal.shareModeManager.isShareMode;

      let contents = '<div class="dialogFittingSetting">\n';
      contents += '<table>\n';
      contents += '<tbody>\n';

      if (!isShareMode) {
        contents += '<div id="radioFittingSettingType">\n';
        contents += '<tr>\n';
        contents += '<td>\n';
        contents += '<input type="radio" name="fittingSettingType" id="fittingSettingType_a"><label for="fittingSettingType_a"><span class="jp">自動設定</span><span class="en">auto setting</span></label>\n';
        contents += '</td>\n';
        contents += '</tr>\n';
        contents += '<tr>\n';
        contents += '<td>\n';
        contents += '<input type="radio" name="fittingSettingType" id="fittingSettingType_b"><label for="fittingSettingType_b"><span class="jp">手動設定</span><span class="en">manual setting</span></label>\n';
        contents += '</td>\n';
        contents += '</tr>\n';
        contents += '</div>\n';
      }

      // 数値設定
      contents += '<table id="fittingSettingGroup">\n';
      contents += '<tbody>\n';
      contents += '<tr>\n';
      contents += '<th>\n<label><span class="jp">高さ</span><span class="en">height</span></label></th>\n';
      contents += '<td>\n<input type="text" name="fittingHeight" id="fittingHeight">\n<td>mm</td>\n</td>\n';
      // if( !this.targetFitting.itemInfo.end_item_info ){
      //   contents += '<td>\n<select name="fittingHeight" id="fittingHeight">';
      //   // ie対応
      //   const list = (<HTMLSelectElement> mySetting.heightList).querySelectorAll('option');
      //   let text = '';
      //   for (let i = 0; i < list.length; i += 1) {
      //     text += `<${list[i].tagName}>${list[i].textContent}</${list[i].tagName}>`;
      //   }
      //   contents += text;
      //   contents += '</select>\n<td>mm</td>\n</td>\n';
      // }else{
      //   //高さ情報がない時
      //   if( !this.targetFitting.itemInfo.heightmm ){
      //     this.targetFitting.itemInfo.heightmm = ( this.targetFitting.itemInfo.end_item_info )?this.targetFitting.itemInfo.end_item_info.item_height: 0;
      //   }
      //   contents += '<td>' + this.targetFitting.itemInfo.heightmm;
      //   contents += '<td>mm</td>\n</td>\n';
      // }

      contents += '</tr>\n';
      contents += '<tr>\n';
      contents += '<th>\n<label for="fittingZ"><span class="jp">取付高さ</span><span class="en">fixing height</span></label></th>\n';
      contents += '<td>\n<input type="text" name="fittingZ" id="fittingZ">\n<td>mm</td>\n</td>\n';
      contents += '</tr>\n';
      contents += '<tr>\n';
      contents += '<td colspan="3" id="fittingSettingAttention">\n<label><span class="jp">※取付高さには上端をご指定ください。</span><span class="en">※Input the top measurement for the fixing height.</span></label>';
      contents += '</td>\n';
      contents += '</tr>\n';
      contents += '</tbody>\n';
      contents += '</table>\n';

      contents += '</tbody>\n';
      contents += '</table>\n';
      contents += '</div>';

      let footer = '';
      if (!isShareMode) {
        footer = '<button id="btnDoneFittingSetting"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
        footer += '<button id="btnCancelFittingSetting"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
      }

      this.createDialog(id, title, contents, footer);

      // ダイアログの初期設定
      this.initMe();

      let btn = null;
      if (!isShareMode) {
        // イベント設定
        btn = document.querySelector('#btnDoneFittingSetting');
        btn.addEventListener('click', this.updateFitting);

        // イベント設定
        document.querySelector('#btnCancelFittingSetting').addEventListener('click', this.close);
      }

      // 各種EventListener
      const fittingRadio1 = document.querySelector('#fittingSettingType_a');
      const fittingRadio2 = document.querySelector('#fittingSettingType_b');
      if (fittingRadio1 && fittingRadio2) {
        fittingRadio1.addEventListener('change', this.updateMe);
        fittingRadio2.addEventListener('change', this.updateMe);
      }

      // お掃除
      title = null;
      contents = null;
      footer = null;
      btn = null;
    }

    /**
     * ダイアログの初期設定
     */
    initMe() {
      // 自動・手動の設定（シェアモードでは生成していないため要素の有無を確認する）
      const radioAutoHeight = document.getElementById('fittingSettingType_a');
      const radioManualHeight = document.getElementById('fittingSettingType_b');
      if (radioAutoHeight && radioManualHeight) {
        if ((this.targetFitting as marietta.webcad.item.Fitting).itemInfo.auto_height) {
          radioAutoHeight.setAttribute('checked', 'checked');
        } else {
          radioManualHeight.setAttribute('checked', 'checked');
        }
      }

      // 高さリストの選択
      if (!(this.targetFitting as marietta.webcad.item.Fitting).itemInfo.auto_height) {
        // 高さの設定
        if( !(this.targetFitting as marietta.webcad.item.Fitting).itemInfo.fitting_height ){
          (<HTMLInputElement>document.getElementById('fittingHeight')).value = ((this.targetFitting as marietta.webcad.item.Fitting).itemInfo.fitting_height).toString();
        }else{
          // 取り付け高さの設定
          (<HTMLInputElement>document.getElementById('fittingHeight')).value = ((this.targetFitting as marietta.webcad.item.Fitting).itemInfo.fitting_height).toString();
        }

        // 取り付け高さの設定
        (<HTMLInputElement>document.getElementById('fittingZ')).value = ((this.targetFitting as marietta.webcad.item.Fitting).itemInfo.z).toString();
      }

      // 初期化完了フラグ
      this.initDone = true;

      // 入力制限の更新
      this.updateMe();
    }

    /**
     * ダイアログの更新
     */
    updateMe = () => {
      if (!this.initDone) return;

      // シェアモードでは値の確認のみとするため、常に入力を無効にする
      // （自動・手動の切り替えを生成していないため要素の有無も確認する）
      const radioManualHeight = <HTMLInputElement>document.getElementById('fittingSettingType_b');
      const enabled: boolean = radioManualHeight != null
        && radioManualHeight.checked
        && marietta.webcad.WebCADGlobal.shareModeManager.canOperateModel;
      if (enabled) {
        if( (<HTMLInputElement>document.getElementById('fittingHeight')) ) document.getElementById('fittingHeight').removeAttribute('disabled');
        document.getElementById('fittingZ').removeAttribute('disabled');
      } else {
        if( (<HTMLInputElement>document.getElementById('fittingHeight')) ) document.getElementById('fittingHeight').setAttribute('disabled', 'disabled');
        document.getElementById('fittingZ').setAttribute('disabled', 'disabled');
      }

      // 選択肢リストの作成
      let mySetting;
      for (let i: number = 0; i < marietta.webcad.WebCADGlobal.FITTING_CONFIG_ITEMS.length; i += 1) {
        if (marietta.webcad.WebCADGlobal.FITTING_CONFIG_ITEMS[i].id === this.targetFitting.itemInfo.id) {
          mySetting = marietta.webcad.WebCADGlobal.FITTING_CONFIG_ITEMS[i];
        }
      }

      //開口の場合は、高さがなければ、天井高さを代入する
      if( this.targetFitting.itemInfo.id === 'fit02_01' ){
        let ceilingHeight = marietta.webcad.view.dialog.RoomSetting.getBasicCeilingHeight( this.targetFitting.itemInfo.floor );
        //上限をつける
        if( this.FITTING_MAX_HEIGHT <  ceilingHeight ) ceilingHeight = this.FITTING_MAX_HEIGHT;

        mySetting = { defaultZ:ceilingHeight };
      }

      // 設定されていないなら設定を行う
      if (!(<HTMLInputElement>document.getElementById('fittingZ')).value) {
        if (mySetting) {
          (<HTMLInputElement>document.getElementById('fittingHeight')).value = mySetting.defaultZ.toString();   //高さの設定
          (<HTMLInputElement>document.getElementById('fittingZ')).value = mySetting.defaultZ.toString();
        }
      }
    }

    /**
     * 建具設定の反映
     */
    updateFitting = () => {
      // 入力チェック
      if( (<HTMLInputElement>document.getElementById('fittingHeight')) ) {
        if ((<HTMLInputElement>document.getElementById('fittingHeight')).value === undefined || (<HTMLInputElement>document.getElementById('fittingHeight')).value === null) {
          marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('FITTINGSETTING_NO_FITTINGHEIGHT'), marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
          return;
        }
      }
      // 取り付け高さ
      if (Number.isNaN(Number((<HTMLInputElement>document.getElementById('fittingZ')).value))) {
        (<HTMLInputElement>document.getElementById('fittingZ')).value = '0';
      }

      // 高さのMIN&MAXの制限
      if (!(<HTMLInputElement>document.getElementById('fittingSettingType_a')).checked) {
        const tateguTakasa: number = Number((<HTMLInputElement>document.getElementById('fittingHeight')).value);
        if (tateguTakasa < this.FITTING_MIN_HEIGHT || tateguTakasa > this.FITTING_MAX_HEIGHT) {
          let message: string;
          if (marietta.webcad.WebCADGlobal.language === 'jp') {
            message = `高さには${this.FITTING_MIN_HEIGHT}mm以上、${this.FITTING_MAX_HEIGHT}mm以下の数値を入力してください。`;
          } else {
            message = `Please input from ${this.FITTING_MIN_HEIGHT}mm (fitting height) to ${this.FITTING_MAX_HEIGHT}mm for the fixing height.`;
          }
          marietta.webcad.WebCADGlobal.showAlert(message, marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
          return;
        }
      }

      // MIN&MAXの制限
      const tateguTakasa: number =  (<HTMLInputElement>document.getElementById('fittingHeight'))?Number((<HTMLInputElement>document.getElementById('fittingHeight')).value):this.targetFitting.itemInfo.heightmm;
      if ( (<HTMLInputElement>document.getElementById('fittingSettingType_a')).checked === false) {
        const tateguZ: number = Number((<HTMLInputElement>document.getElementById('fittingZ')).value);
        if (tateguZ < tateguTakasa || tateguZ > this.FITTING_MAX_HEIGHT) {
          let message: string;
          if (marietta.webcad.WebCADGlobal.language === 'jp') {
            message = `取付高さには${String(tateguTakasa)}mm（建具の高さ）以上、${this.FITTING_MAX_HEIGHT}mm以下の数値を入力してください。`;
          } else {
            message = `Please input from ${String(tateguTakasa)}mm (fitting height) to ${this.FITTING_MAX_HEIGHT}mm for the fixing height.`;
          }
          marietta.webcad.WebCADGlobal.showAlert(message, marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
          return;
        }
      }

      // 設定
      this.targetFitting.setFittingHeightInfo(
        (<HTMLInputElement>document.getElementById('fittingSettingType_a')).checked,
        tateguTakasa,
        Number((<HTMLInputElement>document.getElementById('fittingZ')).value));

      // ダイアログを閉じる
      marietta.webcad.WebCADGlobal.quotationItemList.requestRebuild();
      this.close();
    }
}

export default FittingSetting;
